/**
 * Every string the review surface renders.
 *
 * The lede states what the reviewer is looking at and why it matters that they
 * are looking at the output rather than the fields. Nothing here restates a
 * control the reader can see.
 */
export const copy = {
  crumbs: {
    root: 'لوحة التشغيل',
    list: 'المقالات',
  },

  head: {
    title: 'مراجعة المقال',
    lede: 'المقال كما سيقرأه القارئ، لا كما كُتب. القرار يُتَّخذ على المخرَج — وقرارٌ يُتَّخذ أمام استمارةٍ هو قرارٌ على الحقول لا على المقال.',
  },

  byline: {
    author: (name: string) => `بقلم ${name}`,
    submitted: 'رُفعت في',
    published: 'نُشرت في',
    readingTime: (minutes: string) => `${minutes} دقائق قراءة`,
  },

  tagsLabel: 'وسوم المقال',
  tagsLead: 'الوسوم:',

  railLabel: 'قرار المراجعة',

  state: {
    heading: 'الحالة',
    submittedBy: (author: string, when: string) => `رفعها ${author} في ${when}.`,
    notPublished: 'لم تُنشر بعد، ولا يراها القرّاء.',
    published: 'منشورة، ويقرأها الزوّار الآن.',
    rejectedTitle: 'رُدّ مع السبب',
  },

  review: {
    lead: 'اقرأ المقال كاملاً قبل القرار — ما توافق عليه يصل القرّاء كما هو.',
    approve: 'وافِق وانشر',
    reject: 'ردّ المقال',
    hint: 'الموافقة تنشر المقال في الحال وتثبّت تاريخ نشره. الردّ يعيده إلى كاتبه قابلاً للتحرير ومعه سببك، ولا يراه القرّاء.',
  },

  meta: {
    heading: 'البيانات',
    author: 'الكاتب',
    tags: 'الوسوم',
    thumbnail: 'المصغّرة',
    hero: 'اللوحة',
    related: 'عناوين مرفقة',
    blocks: 'كتل الجسم',
    present: 'مرفوعة',
    derived: 'مشتقّة من المصغّرة',
    missing: 'ناقصة',
    hint: 'ما ينقص يُستدرَك من التحرير قبل الموافقة، لا بعدها.',
  },

  /**
   * The card is drawn from `STATE_ACTIONS`, so each entry here is offered only
   * where that table allows it.
   */
  otherActions: {
    heading: 'أفعال أخرى',
    edit: 'حرّر المقال',
    delete: 'احذف المقال',
    hint: 'الحذف نهائيّ: يُمحى المقال ومعه تعليقاته وسجلّ مراجعته، ولا يُستعاد.',
  },

  announce: {
    published: 'نُشر المقال ويقرأه الزوّار الآن.',
    rejected: 'رُدّ المقال إلى كاتبه مع سببك.',
    deleted: 'حُذف المقال نهائياً.',
  },

  states: {
    loading: 'جارٍ تحميل المقال',
  },
} as const;
